// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

/**
 * Reports errors to GCP Cloud Logging (Stackdriver)
 *
 * Usage:
 *  - `import './errorHandler';` somewhere near startup to enable automatic reporting of uncaught errors
 *  - `errorHandler.setUser('userId')` to identify current user context
 *  - `errorHandler.report(new Error())` to manually report
 *
 */

import StackdriverErrorReporter from "stackdriver-errors-js";

const REMOTE_REPORT_ENABLED =
  process.env.NODE_ENV === "production" &&
  !!process.env.REACT_APP_STACKDRIVER_API_KEY;

const localHandler = {
  report: window.console.error,
  setUser: () => null,
  start: () => null,
};

// original handlers are called by StackDriver
window.onerror = window.onunhandledrejection = (message) => {
  window.ga?.("send", "exception", { exDescription: message });
};

const errorHandler = REMOTE_REPORT_ENABLED
  ? new StackdriverErrorReporter()
  : localHandler;

errorHandler.start({
  key: process.env.REACT_APP_STACKDRIVER_API_KEY,
  projectId: process.env.REACT_APP_STACKDRIVER_PROJECT_ID,
  service: process.env.REACT_APP_NAME,
  version: process.env.REACT_APP_VERSION,
});

export default errorHandler;
